import ElementAnimation from 'containers/OldNewWordsFrame/ElementAnimation';
import SvgObject from 'containers/OldNewWordsFrame/SvgObject';
import * as d3 from 'd3';
import {assert} from 'utils/assert';
import {debuggableClass, memo} from 'utils/decorators';

@debuggableClass
export default class PairGroup {
  constructor(
    public parent: SvgObject,
    public groupG: SVGGElement,
    public getMinStartTime: () => number,
  ) {}
  @memo get sel() {
    return d3.select(this.groupG).classed('pair-group', true);
  }
  @memo get groupId() {
    return this.sel.attr('id');
  }
  @memo get groupNo() {
    const prefix = 'pair_';
    assert(this.groupId.startsWith(prefix));
    const numPart = this.groupId.slice(prefix.length);
    assert(Number.isFinite(Number(numPart)));
    return Number(numPart);
  }
  @memo get oldWordGroupSel() {
    return this.sel.select('g.pair-group > g:nth-of-type(1)');
  }
  @memo get newWordGroupSel() {
    return this.sel.select('g.pair-group > g:nth-of-type(2)');
  }
  @memo get arrowSel() {
    return this.sel.select('path');
  }
  @memo get newWordTextSel() {
    return this.newWordGroupSel.select('text');
  }
  @memo get newWordEllipseGroupSel() {
    return this.newWordGroupSel.select('g');
  }
  @memo get newWordEllipsePathSel() {
    return this.newWordGroupSel.select('path');
  }
  @memo get oldWordGroupAnimation() {
    return new ElementAnimation(this.oldWordGroupSel.node() as SVGElement, 300, 800, 'DOWNSCALE');
  }
  @memo get newWordGroupAnimation() {
    return new ElementAnimation(this.newWordGroupSel.node() as SVGElement, 300, 800, 'UPSCALE');
  }
  @memo get arrowAnimation() {
    return new ElementAnimation(this.arrowSel.node() as SVGElement, 0, 1000, 'LEFT_RIGHT');
  }
  setInitialState() {
    this.oldWordGroupAnimation.setInitialState();
    this.newWordGroupAnimation.setInitialState();
    // this.arrowAnimation.setInitialState();
    return this;
  }
  start() {
    setTimeout(() => {
      this.startAnimation();
    }, Math.max(0, this.startTime - Number(new Date())));
  }
  @memo get started() {
    return false;
  }
  @memo get startTime() {
    return Math.max(this.getMinStartTime(), Number(new Date()));
  }
  startAnimation() {
    Object.defineProperty(this, 'started', {value: true});

    this.oldWordGroupAnimation.start();
    this.newWordGroupAnimation.start();
    // this.arrowAnimation.start();
    return this;
  }
}
